import DayShiftRow from "./DayShiftRow";
import TextInput from "./TextInput";
import CheckboxInput from "./CheckboxInput";

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const WeeklyShiftSchedule = ({ value, onChange, handleEditedChange }) => {
  const updateDay = (dayName, newData) => {
    const updatedDay = {
      WorkingDays: dayName,
      ...newData,
    };

    onChange({
      ...value,
      Days: value.Days.map((d) =>
        d.WorkingDays === dayName ? { ...d, ...newData } : d
      ),
    });

    handleEditedChange("Days", updatedDay);
  };

  return (
    <section className="weekly-shift">
      <h3>Shift Schedule</h3>

      <div className="weekly-shift__meta">
        <TextInput
          label="Schedule Name"
          placeholder="Regular Day Shift"
          value={value.Name}
          onChange={(val) => {
            onChange({ ...value, Name: val });
            handleEditedChange("Name", val);
          }}
        />

        <TextInput
          label="Description"
          placeholder="Monday to Friday, 8:15 AM – 5:15 PM"
          value={value.Description}
          onChange={(val) => {
            onChange({ ...value, Description: val });
            handleEditedChange("Description", val);
          }}
        />
      </div>

      <div className="weekly-shift__days">
        {daysOfWeek.map((day) => {
          const dayValue = value.Days.find((d) => d.WorkingDays === day);
          return (
            <DayShiftRow
              key={day}
              day={day}
              value={dayValue}
              onChange={(data) => updateDay(day, data)}
            />
          );
        })}
      </div>
    </section>
  );
};

export default WeeklyShiftSchedule;
